import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const archiveAndUnarchiveTask = createAsyncThunk(
  "Tasks/archiveAndUnarchiveTask",
  async (data, thunkAPI) => {
    let { handleSuccess, handleError } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/transactions/contracts/archive-unarchive-task/${data.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess && resp.data?.data) {
        handleSuccess();
      }
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
